export default "__VITE_ASSET__CP6fYei6__"